import { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import useScreenWidth from "../../../hooks/useScreenWidth";
import { AuthContext } from "../../../contexts/AuthContext";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Autocomplete,
  TextField,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahPembayaranPiutang = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [inputTanggalPembayaranPiutang, setInputTanggalPembayaranPiutang] =
    useState(new Date());
  const [jualId, setJualId] = useState("");
  const [noNotaJual, setNoNotaJual] = useState("");
  const [noPembayaranPiutang, setNoPembayaranPiutang] = useState("");
  const [jenisPembayaranPiutang, setJenisPembayaranPiutang] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");
  const [totalPembayaranPiutang, setTotalPembayaranPiutang] = useState("");

  const [namaPelanggan, setNamaPelanggan] = useState("");
  const [totalJual, setTotalJual] = useState("");

  const [openJual, setOpenJual] = useState(false);
  const [searchTermJual, setSearchTermJual] = useState("");
  const [juals, setJuals] = useState([]);
  const [coas, setCoas] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClickOpenJual = () => {
    setOpenJual(true);
  };

  const handleCloseJual = () => {
    setOpenJual(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const tempPostsJual = juals.filter((val) => {
    if (searchTermJual === "") {
      return val;
    } else if (
      val.noNotaJual.toUpperCase().includes(searchTermJual.toUpperCase()) ||
      val.totalJual == searchTermJual ||
      val.supplier.namaPelanggan
        .toUpperCase()
        .includes(searchTermJual.toUpperCase())
    ) {
      return val;
    }
  });

  const jenisPembayaranPiutangOption = ["TUNAI", "TRANSFER"];
  let coaOptions = coas.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));

  useEffect(() => {
    getNextKodePembayaranPiutang();
    getCoasData();
    getJualsData();
  }, []);

  const getNextKodePembayaranPiutang = async () => {
    const nextKodePembayaranPiutang = await postRequest(
      `/pembayaranPiutangsNextKode`,
      {},
      navigate,
      dispatch
    );
    setNoPembayaranPiutang(nextKodePembayaranPiutang.data);
  };

  const getCoasData = async () => {
    const response = await postRequest(`/COAsKasBank`, {}, navigate, dispatch);
    setCoas(response.data);
    setKodeCOA(setting.coaKasKasir);
  };

  const getJualsData = async () => {
    const response = await postRequest(
      `/jualsBelumLunas`,
      {},
      navigate,
      dispatch
    );
    setJuals(response.data);
  };

  const savePembayaranPiutang = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      noNotaJual.length !== 0 &&
      jenisPembayaranPiutang.length !== 0 &&
      kodeCOA.length !== 0
    ) {
      setLoading(true);
      try {
        setLoading(true);
        await postRequest(
          `/savePembayaranPiutang`,
          {
            jualId,
            tanggalPembayaranPiutang: inputTanggalPembayaranPiutang,
            jenisPembayaranPiutang,
            kodeCOA,
            totalPembayaranPiutang: totalPembayaranPiutang.replace(/,/g, ""),
          },
          navigate,
          dispatch
        );
        setLoading(false);
        navigate("/pembayaranPiutang");
      } catch (error) {
        if (error.response.status == 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        } else {
          alert(error.response.data.message);
        }
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Penjualan</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Pembayaran Piutang</h5>
      <hr />
      <Card>
        <Card.Header>Pembayaran Piutang</Card.Header>
        <Card.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={savePembayaranPiutang}
          >
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Bayar <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noPembayaranPiutang}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Bayar <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={inputTanggalPembayaranPiutang}
                      customInput={<Form.Control required />}
                      onChange={(date) => {
                        setInputTanggalPembayaranPiutang(date);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Jual <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noNotaJual}
                      readOnly
                      placeholder="Pilih..."
                      onClick={() => handleClickOpenJual()}
                      isInvalid={noNotaJual.length === 0 && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nama Pelanggan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={namaPelanggan}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Jenis Bayar <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={jenisPembayaranPiutangOption}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          error={
                            error && jenisPembayaranPiutang.length === 0 && true
                          }
                          helperText={
                            error &&
                            jenisPembayaranPiutang.length === 0 &&
                            "Jenis Bayar harus diisi!"
                          }
                          {...params}
                        />
                      )}
                      onInputChange={(e, value) => {
                        setJenisPembayaranPiutang(value);
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode Kas :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={coaOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCOA.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCOA(value.label.split(" ", 1)[0]);
                        } else {
                          setKodeCOA("");
                        }
                      }}
                      value={kodeCOA}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Total Piutang :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={totalJual} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Total Bayar :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={totalPembayaranPiutang}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/pembayaranPiutang")}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openJual}
        onClose={handleCloseJual}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Jual`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <SearchBar setSearchTerm={setSearchTermJual} />
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No. Jual
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Total
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Pelanggan
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tempPostsJual
                    .filter((val) => {
                      if (searchTermJual === "") {
                        return val;
                      } else if (
                        val.noNotaJual
                          .toUpperCase()
                          .includes(searchTermJual.toUpperCase()) ||
                        val.totalJual == searchTermJual ||
                        val.supplier.namaPelanggan
                          .toUpperCase()
                          .includes(searchTermJual.toUpperCase())
                      ) {
                        return val;
                      }
                    })
                    .map((user, index) => (
                      <TableRow
                        key={user._id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          "&:hover": { bgcolor: Colors.grey300 },
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setJualId(user.id);
                          setNoNotaJual(user.noNotaJual);
                          setNamaPelanggan(user.pelanggan.namaPelanggan);
                          setTotalPembayaranPiutang(
                            user.totalJual.toLocaleString("en-US")
                          );
                          setTotalJual(user.totalJual.toLocaleString("en-US"));
                          handleCloseJual();
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {user.noNotaJual}
                        </TableCell>
                        <TableCell align="right">
                          {user.totalJual.toLocaleString("en-US")}
                        </TableCell>
                        <TableCell>{user.pelanggan.namaPelanggan}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahPembayaranPiutang;

const colorRed = {
  color: "red",
};

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};
